// Material UI
import { makeStyles } from '@material-ui/core'

export default makeStyles({
  badge: {
    fontSize: 10,
    height: 14,
    minWidth: 14,
    position: 'absolute',
    right: 5,
    top: 10,
    width: 14,
  },
  button: {
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {},
})
